export type IdAttrType = {
  autoincrement?: boolean;
};

export const IdAttrTypeData: IdAttrType = {
  autoincrement: true,
};
